import { z } from "zod";

export const GetDataForReportRunInputSchema = z.object({
    reportId: z.number(),
});

export type GetDataForReportRunInput = z.infer<typeof GetDataForReportRunInputSchema>;